<template>
    <b-container fluid>
        
      <!-- <b-navbar toggleable="md" type="dark" variant="info">
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
              <b-nav-item to="/">Home</b-nav-item>
              
            </b-navbar-nav>
          </b-collapse>
        
      </b-navbar> -->
      <PortalNavbar></PortalNavbar>
      <div class="body-wrapper">
        <div class="body-title">
            <h5 style="color:#2284ab;">Signup</h5>
             <h5 class="justify-content-md-center" style="color:#2284ab;text-align:center">For Employers Who Are Deploying SGB Board Guards</h5>
        </div>
      
        <div class="body-content">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-row class="justify-content-md-center" v-if="signuptype=='all' || signuptype=='newapplication'">
                    <b-col md="7" sm="12" class="mt-2">
                        <div>
                            <!-- <b-form-radio-group v-model="form.RegistrationType"
                                                size="sm" stacked
                                                name="radiosStacked">
                                                <div class="row"><div class="col">
                                <b-form-radio value="first" selected>Resgistration as New Secuirty Guard</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                <b-form-radio value="second">Registration of Affected Secuirty Guards Working through Agencies</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                <b-form-radio value="third" >Recommanded by registered Principal Employer for Registration and Allotment</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                <b-form-radio value="seventh" >Registration on Compassionate Ground</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                  <b-form-radio value="sixth" >Registration by Court Orders</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                <b-form-radio value="fourth" disabled >Registration of Principal Employer (this facility will start shortly)</b-form-radio>
                                </div></div><div class="row"><div class="col">
                                <b-form-radio value="fifth" disabled>Registration of Employer Agency (this facility will start shortly)</b-form-radio>
                                </div></div>
                            </b-form-radio-group>    -->
                            <b-form-group id="gsgblist" horizontal  label-size="sm"
                                label="Registration Type <span style='color:red'>*</span>"
                                label-for="inpregtyp">
                                <b-form-select id="inpregtyp" v-model="form.RegistrationType" :options="options" required class="mb-3" size="sm"></b-form-select>
                            </b-form-group>
                        </div>
                    </b-col>
                </b-row>
                <hr>
                <b-row class="justify-content-md-center">
                    <b-col md="6" sm="12" class="mt-2">
                        <p style="font-size: 17px;color:#2284ab;">Personal Details of User</p>
                        <p></p>
                        <div style="padding: 10px;
                                border: 2px solid #c4c6be;
                                border-radius: 15px;">
                            <b-form-group id="exampleInputGroup1" horizontal
                                    label="First Name *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="text" placeholder="First Name" size="sm"
                                    v-model="form.FirstName"></b-form-input>
                            </b-form-group>
                            <b-form-group id="exampleInputGroup1" horizontal
                                    label="Middle Name *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="text" placeholder="Middle Name" size="sm"
                                    v-model="form.MiddleInitial"></b-form-input>
                            </b-form-group>
                            <b-form-group id="exampleInputGroup1" horizontal
                                    label="Last Name *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="text" placeholder="Last Name" size="sm"
                                    v-model="form.LastName"></b-form-input>
                            </b-form-group>
                            <b-form-group horizontal v-if="signuptype=='employer' || signuptype=='agency'"
                                    label="Company Name" label-size="sm"
                                    label-for="inpconame">
                                <b-form-input id="inpconame"
                                    type="text"
                                    v-model="form.CompanyName"
                                    required size="sm"
                                    placeholder="Organization Name"></b-form-input>    
                            </b-form-group>
                            <b-form-group id="exampleInputGroup2" horizontal
                                    label="Email ID" label-size="sm"
                                    label-for="inpemail">
                                <b-form-input id="inpemail"
                                    type="email"
                                    v-model="form.EmailID"
                                    size="sm"
                                    placeholder="email id"></b-form-input>    
                            </b-form-group>
                            <b-form-group id="exampleInputGroup2" horizontal
                                    label="Mobile *" label-size="sm"
                                    label-for="inpmobile">
                                <b-form-input id="inpmobile"
                                    type="number" 
                                    v-model="form.Mobile"
                                    :state="mobileNumber"
                                    required size="sm" min="1000000000" max="9999999999"
                                    placeholder="10 digit Mobile Number"></b-form-input>    
                            </b-form-group>
                             <b-form-group id="igrpusr" horizontal
                                    label="User Name *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="text" placeholder="User Name" size="sm"
                                    v-model="form.UserName"></b-form-input>
                            </b-form-group>
                            <b-form-group id="igrppwd" horizontal
                                    label="Password *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="password" placeholder="password" size="sm"
                                    v-model="form.Password" :state="passwordConfirmed"></b-form-input>
                            </b-form-group>
                            <b-form-group id="igrppwdc" horizontal
                                    label="Confirm Password *" label-size="sm"
                                    label-for="exampleInput1">
                                <b-form-input type="password" placeholder="password" size="sm"
                                    v-model="confirmpassword" :state="passwordConfirmed"></b-form-input>
                            </b-form-group>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-md-center mt-2" >
                    <b-col md="6" sm="12" style="text-align:right">
                    <b-button type="submit" variant="primary" v-if="!isSaved">Submit</b-button>
                    <b-button type="reset" variant="danger" v-if="!isSaved">Reset</b-button>
                    <b-button variant="secondary" to="/login">Login</b-button>
                    </b-col>
                    
                </b-row>
                <!-- <b-row class="justify-content-md-center mt-2">
                    <b-col md="6" sm="12" style="text-align:right">
                    <b-button variant="secondary" to="/">Login</b-button>
                    </b-col>
                </b-row> -->
                <b-alert :show = "showDismissibleAlert" dismissible 
                        @dismissed="showDismissibleAlert=false"
                        :variant="variant">
                        {{alertText}}
                    </b-alert>
                    <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
            </b-form>
        </div>
        </div>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import PortalNavbar from "@/components/PortalNavbar";
export default {
  props: ["signuptype"],
  components: { Spinner,PortalNavbar },
  data() {
    return {
      form: {
        RegistrationType: 0,
        FirstName: "",
        MiddleInitial: "",
        LastName: "",
        UserName: "",
        EmailID: "",
        Mobile: "",
        Password: "",
        CompanyName: ""
      },
      isSaved: false,
      confirmpassword: "",
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      options: [
        { value: 0, text: "Resgistration as New Secuirty Guard" },
        { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
        {
          value: 2,
          text:
            "Recommanded by registered Principal Employer for Registration and Allotment"
        },
        { value: 3, text: "Registration on Compassionate Ground" },
        { value: 4, text: "Registration by Court Orders" },
        // { value: 14, text: "Registration of Principal Employer" },
        {
          value: 12,
          text: "Registration of Security Guards Working with Private Agency"
        },
        { value: 13, text: "Registration of Employer Agency" }
      ]
    };
  },
  watch: {
    form: {
      handler: function(newValue, oldValue) {
        if (newValue.EmailID != "") {
          this.form.UserName = newValue.EmailID;
        }
      },
      deep: true
    }
  },
  computed: {
    mobileNumber() {
      var phoneno = /^\d{10}$/;
      if (this.form.Mobile.match(phoneno)) {
        if (this.form.UserName == "") {
          this.form.UserName = this.form.Mobile;
        }
        return true;
      } else {
        return false;
      }
    },
    passwordConfirmed() {
      if (
        this.form.Password == this.confirmpassword &&
        this.form.Password != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {

    switch (this.signuptype) {
      case "employer":
       // this.form.RegistrationType = 11;
       this.form.RegistrationType = 11;
        break;
      case "agency":
      this.form.RegistrationType = 13;
        break;
      case "pvtguard":
      this.form.RegistrationType = 12;
        break;
      case "newapplication":
        this.options = [
          { value: 0, text: "Resgistration as New Secuirty Guard" },
          { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
          {
            value: 2,
            text:
              "Recommanded by registered Principal Employer for Registration and Allotment"
          },
          { value: 3, text: "Registration on Compassionate Ground" },
          { value: 4, text: "Registration by Court Orders" }
        ];
        break;
      case "all":
        this.options = [
          // { value: 0, text: "Resgistration as New Secuirty Guard" },
          // { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
          // {
          //   value: 2,
          //   text:
          //     "Recommanded by registered Principal Employer for Registration and Allotment"
          // },
          // { value: 3, text: "Registration on Compassionate Ground" },
          // { value: 4, text: "Registration by Court Orders" },
           { value: 11, text: "Registration of Principal Employer" },
          // {
          //   value: 12,
          //   text: "Registration of Security Guards Working with Private Agency"
          // },
          { value: 13, text: "Registration of Employer Agency" }
        ];
        break;
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.showDismissibleAlert = false;
      this.isLoading = true;
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      if (!this.passwordConfirmed) {
        this.alertText = "Please verify the password and confirm password.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = true;
        return;
      }
      let promise = apis.signup(this.form);

      promise
        .then(response => {
          //console.log("Reponse", response);
          if (response.status == 200) {
            //chck message
            this.alertText = response.body;
            if (response.body == "User Created Successfully") {
              this.variant = "success";
              this.isSaved = true;
            } else {
              this.variant = "warning";
            }
            this.showDismissibleAlert = true;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    onReset(evt) {
      evt.preventDefault();
      this.form.RegistrationType = "";
      this.form.FirstName = "";
      this.form.MiddleInitial = "";
      this.form.LastName = "";
      this.form.UserName = "";
      this.form.EmailID = "";
      this.form.Mobile = "";
      this.form.Password = "";
      this.isSaved = false;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue